import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { baseUrl } from 'constant'
import { handlingErrorResponse } from 'utils/HandlingErrorResponse'
import { ILoginAuthResponsesType, IUserRequestType } from '../types'


export const authApi = createApi({
    reducerPath: 'authApi',
    baseQuery: fetchBaseQuery({ baseUrl:baseUrl }),
    tagTypes: ['Auth'],
    endpoints: (builder) => ({
        LoginAction: builder.mutation<ILoginAuthResponsesType, IUserRequestType>({
            query: userReq => ({
                url: 'auth/signin',
                method: 'POST',
                body: userReq
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'Auth', id: 'Login' }],
        })
    }),
})